import React from 'react';
function Content({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M8.775 3h-4.8A.975.975 0 003 3.975v4.8c0 .538.437.975.975.975h4.8a.975.975 0 00.975-.975v-4.8A.975.975 0 008.775 3zM8.775 14h-4.8a.975.975 0 00-.975.975v4.8c0 .539.437.975.975.975h4.8a.975.975 0 00.975-.975v-4.8A.975.975 0 008.775 14zM14 9.5h4m-4-5h7-7zM14 7h7-7zM14 20h4m-4-5h7-7zm0 2.5h7-7z"
      />
    </svg>
  );
}

export default Content;
